import WelcomeJoin from '@/screens/WelcomeJoin';

export default function PrivateWelcomeJoinRoute() {
  return <WelcomeJoin />;
}
